import React from 'react';
import { Breadcrumb as SpauiBreadcrumb } from '@tencent/spaui';
import _ from 'lodash';
import { getPageConfig } from '@/pages/agency/utils/util';
import { computeGetUrl } from '@/utils';
import './assets/less/index.scoped.less';

export interface BreadcrumbItem {
  /**
   * 名称
   */
  label: string;
  /**
   * 地址
   */
  href?: string;
}

export interface BreadcrumbProps {
  /**
   * 页面地址
   */
  href?: string;
  /**
   * 数据
   */
  data?: BreadcrumbItem[];
  /**
   * 是否显示返回按钮
   */
  useBack?: boolean;
  /**
   * 返回地址
   */
  backHref?: string;
  /**
   * 返回地址
   */
  right?: any;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = (props) => {
  const { href = '', data: _data, useBack = true, backHref, right } = props;
  const { tree = [] } = getPageConfig(href);
  const data = _data?.map((item) => ({ ...item, href: item.href ? computeGetUrl(item.href) : undefined }))
    || (tree.slice(1) as string[]).map((v) => ({ label: v }));

  const back = () => {
    if (backHref) {
      window.location.href = computeGetUrl(backHref);
    } else {
      window.history.back();
    }
  };

  return (
    <div className="base-breadcrumb">
      {
        useBack ? (
          <>
            <i className="icon-back" onClick={back} data-report="page-back" />
            <div className="line-v"></div>
          </>
        ) : null
      }
      <SpauiBreadcrumb data={data} />
      <div className="base-breadcrumb-right">{right}</div>
    </div>
  );
};

Breadcrumb.defaultProps = {
  href: '',
  useBack: true,
};

export default Breadcrumb;
